import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { Button, Row, Col } from 'reactstrap'
import { useTranslation } from 'react-i18next'

import Form from 'main_views/components/Form/form_v2'
import { updateForm, setFieldValue, getFieldsValues } from './formHandler'
import { successToast, errorToast, warningToast } from 'main_views/components/toast'
import { addDoc, updateDoc } from 'dbHandler'
import i18n from 'utils/translation/i18n'

/**
 * show the general info of the form 
 * ( name, reminder Days, & allowFileAttachments)
 *
 */
function GeneralInfoForms(props) {

   let { t } = useTranslation()

   let { selectedFormFields, toggle, updateFormList } = props
   let [form, setForm] = useState(generalInfoFields)
   let [loading, setloading] = useState(false)

   useEffect(() => {
      updateForm(form, selectedFormFields)
   }, [selectedFormFields])

   let setChanges = (stateName, value, className) => {
      setFieldValue(form, stateName, value, className)
      setForm({ ...form }) // to re-render the form 
   }

   let save = async () => {

      setloading(true)

      try {

         let formId = selectedFormFields.id
         let { data } = getFieldsValues(form)

         await updateDoc(data, `forms/${formId}`)

         updateFormList()
         successToast(t('form_info_was_updated'))
         toggle(false)

      } catch (error) {
         console.log({ error })
         errorToast(t('something_wrong'))

      } finally {
         setloading(false)
      }

   }

   return (
      <div style={{ minHeight: '50vh', display: 'grid' }}>

         <Row>
            <Col>
               <Form
                  inputs={form}
                  onChange={setChanges}
               />
            </Col>
         </Row>

         <Row className='align-content-end'>
            <Col>
               <Button
                  color='info'
                  className='float-right'
                  disabled={loading}
                  onClick={save}
               >
                  {t(loading ? 'loading' : 'save')}
               </Button>
            </Col>
         </Row>

      </div>
   )
}

export default GeneralInfoForms

export let generalInfoFields = {
   name: {
      name: i18n.t('form_name'),
      required: true,
      stateName: 'name',
      type: 'TextInput',
   },
   reminderDays: {
      name: i18n.t('reminder_days'),
      required: true,
      stateName: 'reminderDays',
      type: 'NumberInput',
   },
   allowFileAttachments: {
      name: i18n.t('file_attachments'),
      required: true,
      stateName: 'allowFileAttachments',
      type: 'RadioButtons',
      options: [
         {
            id: 'noFile',
            value: i18n.t('no_file_attachments'),
            checked: false,
         },
         {
            id: 'onlyOne',
            value: i18n.t('allow_only_one_file_attachments'),
            checked: false,
         },
         {
            id: 'multi',
            value: i18n.t('allow_multiple_attachments'),
            checked: false,
         },
      ]
   }
}

